import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import { useAnnouncementDetailContext } from "contexts/AnnouncementDetailContext";
import { useSearchParams } from "react-router-dom";
import AnnouncementResponsesTab from "./AnnouncementResponsesTab";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";

export const AnnouncementDetailTabs = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "responses";
  const { loadingAnnouncementDetail } = useAnnouncementDetailContext();

  const tabs = [
    {
      label: "Responses",
      value: "responses",
    },
  ];
  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {!loadingAnnouncementDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="responses">
            <AnnouncementResponsesTab />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};
